import { useMemo } from 'react';
import { SingleTenantId } from '../../../../base/Constants';
import createPermissionFeatureWithoutStoreHook from './CreatePermissionFeatureWithoutStoreHook';
export default function createSingleTenantPermissionFeatureHook(permissionEnum) {
    var usePermissionFeatureWithoutStore = createPermissionFeatureWithoutStoreHook()(permissionEnum);
    return function () {
        var permissionFeatureWithoutStore = usePermissionFeatureWithoutStore();
        var singleTenantPermissionFeatureHookFunctions = useMemo(function () {
            return {
                hasPermission: function (permission) {
                    return permissionFeatureWithoutStore.hasPermission(SingleTenantId, permission);
                },
                hasPermissions: function (permission) {
                    return permissionFeatureWithoutStore.hasPermissions(SingleTenantId, permission);
                },
                getPermissions: function () {
                    return permissionFeatureWithoutStore.getPermissions(SingleTenantId);
                }
            };
        }, [permissionFeatureWithoutStore]);
        return singleTenantPermissionFeatureHookFunctions;
    };
}
//# sourceMappingURL=CreateSingleTenantPermissionFeatureHook.js.map